export var NetworkType;
(function (NetworkType) {
    NetworkType["MAINNET"] = "mainnet";
    NetworkType["GHOSTNET"] = "ghostnet";
    NetworkType["WEEKLYNET"] = "weeklynet";
    NetworkType["DAILYNET"] = "dailynet";
    NetworkType["DELPHINET"] = "delphinet";
    NetworkType["EDONET"] = "edonet";
    NetworkType["FLORENCENET"] = "florencenet";
    NetworkType["GRANADANET"] = "granadanet";
    NetworkType["HANGZHOUNET"] = "hangzhounet";
    NetworkType["ITHACANET"] = "ithacanet";
    NetworkType["JAKARTANET"] = "jakartanet";
    NetworkType["KATHMANDUNET"] = "kathmandunet";
    NetworkType["LIMANET"] = "limanet";
    NetworkType["MUMBAINET"] = "mumbainet";
    NetworkType["NAIROBINET"] = "nairobinet";
    NetworkType["OXFORDNET"] = "oxfordnet";
    NetworkType["PARISNET"] = "parisnet";
    NetworkType["QUEBECNET"] = "quebecnet";
    NetworkType["RIONET"] = "rionet";
    NetworkType["SEOULNET"] = "seoulnet";
    NetworkType["SHADOWNET"] = "shadownet";
    NetworkType["TALLINNNET"] = "tallinnnet";
    NetworkType["TEZLINK_SHADOWNET"] = "tezlink-shadownet";
    NetworkType["CUSTOM"] = "custom";
})(NetworkType || (NetworkType = {}));
//# sourceMappingURL=NetworkType.js.map